import React, { useState, useEffect } from 'react';
import { badgesAPI } from '../../lib/api';
import { useLanguage } from '../../contexts/LanguageContext';

export const TrustBadges = () => {
  const [badges, setBadges] = useState([]);
  const [loading, setLoading] = useState(true);
  const { t } = useLanguage();

  useEffect(() => {
    const fetchBadges = async () => {
      try {
        const response = await badgesAPI.getAll();
        setBadges(response.data || []);
      } catch (error) {
        console.error('Error fetching badges:', error);
      } finally {
        setLoading(false);
      }
    };
    fetchBadges();
  }, []);

  if (loading || badges.length === 0) {
    return null;
  }

  return (
    <section className="py-12 bg-muted/30" data-testid="trust-badges-section">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <h3 className="text-center text-sm font-medium text-muted-foreground uppercase tracking-wider mb-8">
          {t('trustedBy')}
        </h3>
        <div className="flex flex-wrap items-center justify-center gap-8 md:gap-12">
          {badges.map((badge) => (
            <div
              key={badge.id}
              className="flex items-center justify-center grayscale hover:grayscale-0 opacity-70 hover:opacity-100 transition-all duration-300"
              title={badge.name}
              data-testid={`trust-badge-${badge.id}`}
            >
              <img
                src={badge.image_url}
                alt={badge.name}
                className="h-12 md:h-16 w-auto object-contain"
              />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default TrustBadges;
